<template>
<div :class="bem()">
    <div>
        <div v-if="activeType === isPhoneWay" :class="bem('title')">{{isPwdLogin ? '账号密码登录' : '短信验证码登录'}}</div>
        <div v-else :class="bem('title')">{{isEmailLogin ? '账号密码登录' : '邮箱验证码登录'}}</div>
    </div>
    <Tabs v-model="activeType" @change="tabChange">
        <TabPanel :key="isPhoneWay" tab="手机号"></TabPanel>
        <TabPanel :key="isEmailWay" tab="邮箱"></TabPanel>
    </Tabs>
</div>

</template>
<script>
import _TabPanel from "@gaoding/gdui/lib/tab-panel";
import _Tabs from "@gaoding/gdui/lib/tabs";
//
//
//
//
//
//
//
//
//
//
//
//
//
import bemMixin from '../bem';
export default {
  name: 'g-auth-switch-login-tab',
  inject: ['vm'],
  components: {
    Tabs: _Tabs,
    TabPanel: _TabPanel
  },
  mixins: [bemMixin],
  props: {
    type: {
      type: String,
      default: 'pwd' // wechat: 展示微信登录 icon   phone: 展示手机登录 icon

    }
  },
  computed: {
    activeType: {
      get: function get() {
        return ['pwd', 'sms'].includes(this.type) ? '手机号' : '邮箱';
      },
      set: function set() {}
    },
    isPhoneWay: function isPhoneWay() {
      return '手机号';
    },
    isEmailWay: function isEmailWay() {
      return '邮箱';
    },
    isPwdLogin: function isPwdLogin() {
      // 密码或短信验证码
      return this.type === 'pwd';
    },
    isEmailLogin: function isEmailLogin() {
      // 密码或邮箱验证码
      return this.type === 'email';
    }
  },
  mounted: function mounted() {
    var _this = this;

    // @FIXED forceUpdate 适配 safari
    setTimeout(function () {
      _this.$forceUpdate();
    }, 0);
  },
  methods: {
    isIncludesWay: function isIncludesWay(type) {
      return this.vm.loginWays.includes(type);
    },
    tabChange: function tabChange(type) {
      this.vm.switchType(type == '手机号' ? 'phone' : 'email');
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-switch-login-tab .g-auth-switch-login-tab__title {
  line-height: 20px;
  font-size: 20px;
  font-weight: 500;
  height: 20px;
  margin-bottom: 12px;
  text-align: center;
  font-family: PingFang SC;
  color: #000;
}

</style>
